import { Component, Input } from '@angular/core';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { ExportData, ExportFilter, ExportPeriod } from 'src/app/models/filter-objects';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
import * as FileSaver from 'file-saver';
import { FileExportService } from 'src/app/common/file-export-service';

@Component({
    selector: 'export-files',
    templateUrl: './web-export.component.html',
    styleUrl: './web-export.component.scss',
    standalone: false
})
export class WebExportComponent {

  // This property controls whether the button is visible or not
  @Input()
  public IsExportEnable: boolean = false;

  @Input()
  public IsFromPeriod: boolean = false;

  @Input()
  public IsToPeriod: boolean = false;

  @Input()
  public IsAggrEnable: boolean = true;

  @Input()
  public Type: string = "";

  @Input()
  public Title: string = "";

  @Input()
  public Filename: string = "";

  @Input()
  public Filters: ExportFilter[] = [];

  @Input()
  public FileType: string = "xlsx";

  @Input()
  public Hint: string = "Export data to Excel";

  @Input()
  public PopupTitle: string = "Export Data";

  @Input()
  public PopupWidth: number = 720;

  @Input()
  public PopupHeight: number = 230;

  constructor(private fileExportService: FileExportService) { }

  ExportPeriod: ExportPeriod[];
  popupPeriodExportVisible = false;
  onExportButtonClicked() {
    if (this.IsFromPeriod || this.IsToPeriod) {
      if (this.ExportPeriod == null || this.ExportPeriod == undefined) {
        this.ExportPeriod = [];
        this.fileExportService.ExportPeriodData(this.Type, { showLoadingIndicator: false, loadingIndicatorLoggingEnabled: false, errorLoggingEnabled: false }).subscribe(data => {
          this.ExportPeriod = data ?? [];
          this.popupPeriodExportVisible = true;
        }, err => { console.log("Get Export Period Data Service Error", err); });
      }
      else {
        this.popupPeriodExportVisible = true;
      }
    }
    else if (this.IsAggrEnable) {
      this.popupPeriodExportVisible = true;
    }
    else {
      this.exportToExcel();
    }
  }

  exportFromPeriod = "";
  exportToPeriod = "";
  IsAggr = false;

  fileDownloadData: FilePathCollection = new FilePathCollection();
  exportToExcel() {
    let newData = new ExportData();
    newData.fromPeriod = this.exportFromPeriod;
    newData.toPeriod = this.exportToPeriod;
    newData.isAgg = 0;
    if (this.IsAggr) {
      newData.isAgg = 1;
    }
    newData.type = this.Type;
    newData.title = this.Title;
    newData.filename = this.Filename;
    newData.filters = this.Filters;
    newData.fileType = this.FileType;

    this.fileExportService.ExportToFile(newData, { showLoadingIndicator: true, loadingIndicatorLoggingEnabled: false, errorLoggingEnabled: false }).subscribe(resultFilename => {
      this.fileDownloadData.FileName = resultFilename.fieldName;
      this.fileDownloadData.LinkType = 1;
      this.fileExportService.DownloadFile(this.fileDownloadData).subscribe(result => {
        const blob = new Blob([result], { type: EXCEL_TYPE });
        FileSaver.saveAs(blob, this.fileDownloadData.FileName);
      }, error => console.error('Error downloading the file', error),
        () => console.info('File downloaded successfully'));

    }, err => {
      console.log("Get Export Data Service Error", err);
    });
  }

}
